
export class FailureResponseModel {
    constructor(
        public Name: string,
        public Reason: string) {
    }
}
